import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import {withStyles} from "@material-ui/core/styles";
// core components
import Header from "components/Header/Header.jsx";
import projectPageStyle from "../../../assets/jss/material-kit-react/views/projectPage";
import Parallax from "../../../components/Parallax/Parallax";
import HeaderLinks from "../HeaderLinks";
import {Projects} from "../../../database/dictionary";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";

import Footer from "../Sections/Footer";
import Badge from "../../../components/Badge/Badge"
import YouTube from "react-youtube";

import "../../../assets/css/video.css";
import MobileStoreButton from "react-mobile-store-button";
import Button from "../../../components/CustomButtons/Button";
import {MetaTags} from "react-meta-tags";

// @material-ui/icons

class ProjectPage extends React.Component {
    constructor(props) {
        super(props);

        let project = this.getProject();

        this.state = {
            project: project,
        };
    }

    getProject() {
        return Projects.find(item => item.id === this.props.match.params.id);
    }

    render() {
        const {classes, ...rest} = this.props;
        let project = this.state.project;
        return (
            <div className={classNames(classes.root)}>
                <MetaTags>
                    <title>{project.name}</title>
                    <meta property="og:title" content={project.name} />

                    <meta name="description" content={project.tagline} />
                    <meta property="og:description" content={project.tagline} />

                    <meta property="og:image" content={project.image} />
                    <meta property="og:url" content={this.props.location} />
                </MetaTags>
                <Header
                    color="transparent"
                    brand="HOME"
                    rightLinks={<HeaderLinks/>}
                    fixed
                    changeColorOnScroll={{
                        height: 100,
                        color: "white"
                    }}
                    {...rest}
                />
                <Parallax small filter image={project.image}>
                    <div className={classNames(classes.container, classes.raised)}>
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={12} md={6}>
                                <h1 className={classNames(classes.title, classes.textCenter)}>{project.name}</h1>

                                <GridContainer justify="center" spacing={12} alignItems={"center"}>
                                    {
                                        project.tags.map(item =>
                                            <GridItem className={classes.tag}>
                                                <Badge
                                                    style={{backgroundColor: item.color}}
                                                    key={item.name}>{item.name}</Badge>
                                            </GridItem>)
                                    }
                                </GridContainer>

                                <GridContainer justify="center" spacing={24}>
                                    {
                                        project.ios ?
                                            <GridItem>
                                                <MobileStoreButton
                                                    store="ios"
                                                    url={project.ios}
                                                    style={{
                                                        height: "50px",
                                                        width: "150px",
                                                        display: "block",
                                                        margin: "0 auto",
                                                    }}
                                                />
                                            </GridItem>
                                            : <div/>
                                    }
                                    {
                                        project.android ?
                                            <GridItem>
                                                <MobileStoreButton
                                                    store="android"
                                                    url={project.android}
                                                    style={{
                                                        height: "50px",
                                                        width: "150px",
                                                        display: "block",
                                                        margin: "0 auto",
                                                    }}
                                                />
                                            </GridItem>
                                            : <div/>
                                    }
                                    {
                                        project.link ?
                                            <GridItem>
                                                <Button
                                                    color={"success"}
                                                    href={project.link}
                                                    target="_blank"
                                                    style={{
                                                        width: "150px",
                                                        display: "block",
                                                        margin: "0 auto",
                                                    }}>Demo</Button>
                                            </GridItem>
                                            : <div/>
                                    }
                                </GridContainer>
                            </GridItem>
                        </GridContainer>
                    </div>
                </Parallax>
                <div className={classNames(classes.main)}>
                    <div className={classes.container}>
                        <h2>
                            Role
                        </h2>
                        <p>
                            <b>{project.role}</b>
                        </p>
                        <h2>Description</h2>
                        <p>{project.description}</p>

                        {project.slides ?
                            <iframe src={project.slides}
                                    width="595"
                                    height="485" frameBorder="0" marginWidth="0" marginHeight="0" scrolling="no"
                                    style={{
                                        border: "1px solid #CCC",
                                        borderWidth: "1px",
                                        margin: "16px auto",
                                        maxWidth: "100%",
                                        display: "block"
                                    }}
                                    allowFullScreen/>
                            : <div/>
                        }

                        {project.video ?
                            <GridContainer justify={"center"} className={"videoWrapper"}>
                                <YouTube
                                    videoId={project.video}
                                    opts={{
                                        height: '390',
                                        width: '640',
                                        playerVars: { // https://developers.google.com/youtube/player_parameters
                                            autoplay: 0
                                        }
                                    }}
                                />
                            </GridContainer>
                            : <div/>
                        }
                        {
                            project.media ?
                                <div>
                                    <h2>Gallery</h2>
                                    <GridContainer spacing={24} alignItems="stretch">
                                        {
                                            project.media.map(item =>
                                                <GridItem md={6} xs={12}>
                                                    <div style={{backgroundImage: "url(" + item + ")"}}
                                                         className={
                                                             classes.imgRaised +
                                                             " " +
                                                             classes.imgRounded +
                                                             " " +
                                                             classes.imgFluid
                                                         }/>
                                                </GridItem>
                                            )
                                        }
                                    </GridContainer>
                                </div> : <div/>
                        }
                    </div>
                </div>
                < Footer/>
            </div>
        )
    }
}

export default withStyles(projectPageStyle)(ProjectPage);


// WEBPACK FOOTER //
// ./src/views/LandingPage/pages/ProjectPage.jsx